import { render } from "./ConfirmForm.vue?vue&type=template&id=5ccf9f04"
import script from "./ConfirmForm.vue?vue&type=script&lang=js"
export * from "./ConfirmForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/timecard-test/OggiTimeClockSystem/electron/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__